import { useQuery } from '@tanstack/react-query'
import { fetchSuspectedOrders } from 'http/admin/fetch-suspected-orders'

export const useSuspectedOrders = () => {
  return useQuery({
    queryKey: ['suspected-orders'],
    queryFn: () => fetchSuspectedOrders(),
  })
}
